import React from "react";
import PropTypes from "prop-types";

// mui
import { Typography } from "@material-ui/core";

// styles
import { useStyles } from "./style";

const NoDataPreview = ({ title }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div>
                <svg className={classes.icon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 13h6m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                </svg>
                <div className={classes.fullWidth}>
                    <Typography variant="h2">{title}</Typography>
                    <span className={`${classes.loader}`} />
                    <span className={`${classes.loader} ${classes.twoThird}`} />
                </div>
            </div>
        </div>
    );
};

export default NoDataPreview;

NoDataPreview.propTypes = {
    title: PropTypes.string.isRequired,
};
